import {SINGLE_PROJECT_PRESENTATION_TEMPLATE} from '../../configs/slides';
import {
  duplicateTemplate,
  createProjectSlides,
  getUrl,
  findOrCreateFolder
} from './operations';

import type {Project, ProjectDraft} from '../../types/project';

function createSlidesHelper() {
  return {
    createPresentation: (
      projects: Array<Project | ProjectDraft>,
      onSuccess: () => void,
      onUrlCreated: (url: string) => void,
      onError: (error: unknown) => void
    ) => {
      const fileName =
        projects.length > 2
          ? `Export: ${projects.length} Projects`
          : `Export: ${projects.map(project => project.title).join(', ')}`;
      findOrCreateFolder()
        .then(folderId => {
          duplicateTemplate(
            SINGLE_PROJECT_PRESENTATION_TEMPLATE,
            folderId,
            fileName
          )
            .then(presentationId => {
              getUrl(presentationId)
                .then(onUrlCreated)
                .catch(error => {
                  console.error(
                    'Could not export to Google Slides – Error getting slides URL',
                    error
                  );
                  onError(error);
                });
              return presentationId;
            })
            .then(presentationId => {
              createProjectSlides(presentationId, projects).catch(error => {
                console.error(
                  'Could not export to Google Slides – Error creating slides',
                  error
                );
                onError(error);
              });
            })
            .then(onSuccess)
            .catch(error => {
              console.error(
                'Could not export to Google Slides – Error duplicating template',
                error
              );
              onError(error);
            });
        })
        .catch(error => {
          console.error(
            'Could not export to Google Slides – Error finding or creating Drive folder',
            error
          );
          onError(error);
        });
    }
  };
}

export default createSlidesHelper();
